import { Component, Input, TemplateRef } from '@angular/core';
import { DataItem } from '@swimlane/ngx-charts';
import { charts as chartsCatalog } from 'src/app/utils/catalog';

export interface ChartData extends DataItem {
  units?: string;
}

export interface ChartAction {
  template: TemplateRef<any>;
  data?: any;
}

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
})
export class ChartComponent {
  @Input('label') public label: string = '';
  @Input('actions') public actions: Array<ChartAction> = [];
  @Input('type') public type: string = chartsCatalog.types.verticalBar;
  @Input('meterType') public meterType: string = null;
  @Input('data') public data: Array<ChartData> = [];
  @Input('dataLoaded') public dataLoaded: boolean = false;

  public types = chartsCatalog.types;

  public colorScheme: any = {
    domain: ['#EC7A08', '#4CB140', '#5752D1', '#009596', '#F4B678', '#C9190B', '#8BC1F7', '#F4C145', '#519DE9', '#B2B0EA', '#A2D9D9', '#F9E0A2', '#BDE2B9'],
  };

  public baseColorSchema: any = {
    domain: ['#1e78ba'],
  };

  constructor() {}

  public formatVerticalBarChartYAxisLabel = (value: number) => {
    const [item] = this.data;
    if (!item) return `${value}`;
    return `${value} ${item.units}`;
  };

  public formatHorizontalBarChartXAxisLabel = (value: number) => {
    const [item] = this.data;
    if (!item) return `${value}`;
    return `${value} ${item.units}`;
  };

  public formatPieChartLabel = (value: any) => {
    const item = this.data.find((d) => d.name === value);
    if (!item) return value;
    return `${item.name} - ${item.value} ${item.units}`;
  };
}
